import { SupportedMimeType } from '../types/media.enums';

/**
 * Detect video MIME type from a URL by examining the file extension in the path.
 * Falls back to 'video/mp4' if extension is unrecognizable.
 */
export function detectVideoMimeType(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    const ext = pathname.split('.').pop()?.toLowerCase();

    switch (ext) {
      case 'webm':
        return SupportedMimeType.VIDEO_WEBM;
      case 'mov':
        return 'video/quicktime';
      case 'mp4':
      default:
        return SupportedMimeType.VIDEO_MP4;
    }
  } catch {
    return SupportedMimeType.VIDEO_MP4;
  }
}
